export enum GradeTypeStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
